function getSelectedValueImage() {
  if(document.querySelector("variant-selects")){
  const variantFieldSet = document.querySelector("variant-selects");
  const variantImages = variantFieldSet.querySelectorAll(".color_swatch .mat-box");
  let multipleImage = "";
  variantImages.forEach(input => {
    const multipleElement = input.querySelector("input[type='radio']:checked");

    if (multipleElement) {
      const label = multipleElement.nextElementSibling;
      const img = label ? label.querySelector('img') : null;
      if (img) {
        multipleImage += `<img class="custom_variant_image" src="${img.src}">`;
      }
    }
  });
  if (multipleImage) {
    const multiFieldSet = variantFieldSet.querySelectorAll(".option-bundle-save");
    multiFieldSet.forEach(input => {
      const getCheckedInput = input.querySelector("input[type='radio']:checked");
      
      const appendImage = getCheckedInput ? getCheckedInput.nextElementSibling : null;
      if (appendImage) {
        appendImage.querySelector(".variant_custom_image").innerHTML = multipleImage;
        appendImage.querySelector(".variant_custom_image").classList.add("active");
      }else{
        appendImage.querySelector(".variant_custom_image").classList.remove("active");
      }
    });
  }
  }
}

function getSelectedValueImagecustom() {
  if(document.querySelector("variant-selects-custom")){
  const variantFieldSet = document.querySelector("variant-selects-custom");
  const variantImages = variantFieldSet.querySelectorAll(".variant-selects-custom .active-bundle");
  let multipleImage = "";
  variantImages.forEach(input => {
    const multipleElement = input.querySelector("input[type='radio']:checked");
    input.closest('.product-form__input--swatch').querySelector('.selectedValue').innerHTML = multipleElement.value
    if (multipleElement) {
      const label = multipleElement.nextElementSibling;
      const img = label ? label.querySelector('img') : null;
      if (img) {
        multipleImage += `<img class="custom_variant_image" src="${img.src}">`;
      }
    }
  });
  if (multipleImage) {
    const multiFieldSet = document.querySelector(".product__info-container").querySelectorAll(".option-bundle-save");
    
    multiFieldSet.forEach(input => {
      const getCheckedInput = input.querySelector("input[type='radio']:checked");
      const appendImage = getCheckedInput ? getCheckedInput.nextElementSibling : null;
      if (appendImage) {
        appendImage.querySelector(".variant_custom_image").innerHTML = multipleImage;
        appendImage.querySelector(".variant_custom_image").classList.add("active");
      }else{
        appendImage.querySelector(".variant_custom_image").classList.remove("active");
      }
    });
  }
  }
}

function getSelectedValues() {
    // Get selected value for Group 1
    let selectedGroup1 = $("#mat-1 input[type='radio']:checked").val() || $('.mat-box ul li:first-child input[type=radio]').val();
    $("#mat-1 .selectedValue").text(selectedGroup1);

    // Get selected value for Group 2
    let selectedGroup2 = $("#mat-2 input[type='radio']:checked").val() || $('.mat-box ul li:first-child input[type=radio]').val();
    $("#mat-2 .selectedValue").text(selectedGroup2);

    // Get selected value for Group 3
    let selectedGroup3 = $("#mat-3 input[type='radio']:checked").val() || $('.mat-box ul li:first-child input[type=radio]').val();
    $("#mat-3 .selectedValue").text(selectedGroup3);

  const myTimeout = setTimeout(getSelectedValueImage, 100);
  const myTimeout1 = setTimeout(getSelectedValueImagecustom, 50);
}

// On page load, get selected values
$(document).ready(getSelectedValues);

// On change, update selected values
$(document).on("change", "input[type='radio']", getSelectedValues);
$(document).on("change", ".color_swatch.variant-selects-custom input[type='radio']", getSelectedValues);


$(document).ready(function(){
  $('.thumbnail-list__item').click(function(){
    var data_video = $(this).data('media-type');
     if(data_video == 'video'){
         $('.pro_tag, .pro_size, button.product-popup-modal__button.media_btn.link').hide()
     }else{
         $('.pro_tag, .pro_size, button.product-popup-modal__button.media_btn.link').show()
     }
})

  
  $('.media_btn').click(function(){
    $('.thumbnail-slider .thumbnail-list.slider li:nth-child(2) button').trigger('click')
       $('.pro_tag, .pro_size, button.product-popup-modal__button.media_btn.link').hide()
})
      $('details-accordion summary-accordion').click(function(){
      $(this).closest('details-accordion').find(".accordion__content_accordion").slideToggle(200);
      $(this).closest('details-accordion').toggleClass("is-active"); 
    })

  var selected = $(".product-form__input--pill.option-bundle-save.custom-bundle input[type='radio']:checked").val();
  var price = $(".product-form__input--pill.option-bundle-save.custom-bundle input[type='radio']:checked").next('.variant_image').find('.mat_price').text().replace("/per unit", "").replace("/unit", "").replace("$", "");
  var compare = $('s.price-item.price-item--regular').data('price')
  $('.variant_custom_image').removeClass('active')
  console.log('compare', compare) 
  if(selected == 'trio'){
    $('.color_swatch.variant-selects-custom .product-form__input--swatch').addClass('active-bundle')
    $('label[for="trio"] .variant_custom_image').removeClass('active')
    price = price * 3;
    compare = compare * 3;
    
  }
  if(selected == 'double'){
    $('.color_swatch.variant-selects-custom .option-bundle-2').addClass('active-bundle')
    $('.color_swatch.variant-selects-custom .option-bundle-3').removeClass('active-bundle')
    $('label[for="double"] .variant_custom_image').removeClass('active')
    price = price * 2;
    compare = compare * 2;
    
  }
  if(selected == 'single'){
    $('.color_swatch.variant-selects-custom .option-bundle-2').removeClass('active-bundle')
    $('.color_swatch.variant-selects-custom .option-bundle-3').removeClass('active-bundle')
    $('label[for="single"] .variant_custom_image').removeClass('active')
    price = price * 1;
    compare = compare * 1;
    
  }
  $('span.price-item.price-item--sale.price-item--last').text('$'+price.toFixed(2) + ' USD')
  $('s.price-item.price-item--regular').text('$'+ (compare / 100).toFixed(2)  + ' USD')
  
  
$("body").on("click", ".product-form__input--pill.option-bundle-save.custom-bundle input[type='radio']", function(){
  
  var price = $(this).next('.variant_image').find('.mat_price').text().replace("/per unit", "").replace("$", "").replace("/unit", "");
  var compare = $('s.price-item.price-item--regular').data('price')
  console.log('compare', compare) 
  
  if($(this).val() == 'trio'){
    $('.color_swatch.variant-selects-custom .product-form__input--swatch').addClass('active-bundle')
    price = price * 3;
    compare = compare * 3;
    
  }
  if($(this).val() == 'double'){
    $('.color_swatch.variant-selects-custom .option-bundle-2').addClass('active-bundle')
    $('.color_swatch.variant-selects-custom .option-bundle-3').removeClass('active-bundle')
    price = price * 2;
    compare = compare * 2;
    
  }
  if($(this).val() == 'single'){
    $('.color_swatch.variant-selects-custom .option-bundle-2').removeClass('active-bundle')
    $('.color_swatch.variant-selects-custom .option-bundle-3').removeClass('active-bundle')
    price = price * 1;
    compare = compare * 1;
    
  }
    console.log('price-------', price.toFixed(2))
  $('span.price-item.price-item--sale.price-item--last').text('$'+price.toFixed(2) + ' USD')
  $('s.price-item.price-item--regular').text('$'+(compare / 100).toFixed(2)  + ' USD')
  
});
     function refreshCartDrawer() {

    fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then((responseText) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');
            const newCartDrawer = doc.querySelector('#CartDrawer'); // Update this selector if needed
            const cartDrawer = document.querySelector('#CartDrawer');
            document.querySelector('cart-drawer').classList.remove("is-empty")
            if (cartDrawer && newCartDrawer) {
                cartDrawer.innerHTML = newCartDrawer.innerHTML;
            }
          document.getElementById('cart-icon-bubble').click();

        })
        .catch(error => console.error('Error refreshing cart drawer:', error));
}
 $("body").on("click", ".product-form__submit", function(){
    var selectedVariants = [];
    $(".variant-selects-custom .option-color.active-bundle").each(function() {
        let checkedInputs = $(this).find("input:checked");
        checkedInputs.each(function() {
          let variantId = $(this).data("id");
          let quantity = $('.quantity__input').val(); // Get quantity input
          selectedVariants.push({
            id: parseInt(variantId),
            quantity: parseInt(quantity)
          });
        });
    });
    // Send data via AJAX to the cart page
    $.ajax({
        url: "/cart/add.js", // Adjust based on your actual cart URL
        type: "POST",
        data: JSON.stringify({ items: selectedVariants }),
        contentType: "application/json",
        dataType: "json",
        success: function(response) {
           refreshCartDrawer()
        },
        error: function(xhr, status, error) {
                           alert('not')
        }
    });

    });
});

